// extracted by mini-css-extract-plugin
export default {"products":"PA-z","card":"QA-z","oosMessaging":"RA-z"};